export const DIAGNOSTIC_CONSTANTS = {
  heading: 'Diagnósticos',
  help: 'PRE = Presuntivo; DEF = Definitivo',
  description: 'Descripción',
  code: 'CIE',
  pre: 'PRE',
  def: 'DEF'
};
